import { WarningType } from 'core/enums';
import { Color } from 'theme/enums';

export const warningTypeColorMap = {
  [WarningType.ERROR]: Color.DANGER,
  [WarningType.VALIDATED]: Color.SUCCESS,
  [WarningType.WARNING]: Color.WARNING,
};
